import React, { useState, useEffect } from "react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";

const EntityForm = ({ entity, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    clte_codigo: "",
    nombre: "",
    razon: "",
    nit: "",
    direccion: "",
    telefono: "",
    telefono1: "",
    email: "",
  });

  useEffect(() => {
    if (entity && Object.keys(entity).length > 0) {
      setFormData({
        clte_codigo: entity.clte_codigo || "",
        nombre: entity.nombre || "",
        razon: entity.razon || "",
        nit: entity.nit || "",
        direccion: entity.direccion || "",
        telefono: entity.telefono || "",
        telefono1: entity.telefono1 || "",
        email: entity.email || "",
      });
    }
  }, [entity]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onSave(formData); // ← Deja que el padre maneje los mensajes
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  const title = entity ? "Editar cliente" : "Nuevo cliente";
  const submitText = entity ? "Actualizar" : "Crear";

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      {/* Contenedor con scroll interno */}
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <Card className="border-none shadow-none">
          <CardContent className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 text-xl leading-none"
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-3">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div>
                  <label className="block text-sm font-medium">Código *</label>
                  <input
                    type="text"
                    name="clte_codigo"
                    value={formData.clte_codigo}
                    onChange={handleChange}
                    placeholder="Ej: C5"
                    className="w-full border rounded-lg p-2 disabled:bg-gray-100 disabled:text-gray-500"
                    disabled={!!entity}
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium">Nombre *</label>
                  <input
                    type="text"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    placeholder="Ej: Clínica VetPlus"
                    className="w-full border rounded-lg p-2"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium">Razón social</label>
                <input
                  type="text"
                  name="razon"
                  value={formData.razon}
                  onChange={handleChange}
                  placeholder="Ej: Clínica VetPlus S.A.S"
                  className="w-full border rounded-lg p-2"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div>
                  <label className="block text-sm font-medium">NIT *</label>
                  <input
                    type="text"
                    name="nit"
                    value={formData.nit}
                    onChange={handleChange}
                    placeholder="Ej: 901234567-8"
                    className="w-full border rounded-lg p-2"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium">Correo</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Ej: contacto@vetplus.com"
                    className="w-full border rounded-lg p-2"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium">Dirección</label>
                <input
                  type="text"
                  name="direccion"
                  value={formData.direccion}
                  onChange={handleChange}
                  placeholder="Ej: Calle 123 #45-67"
                  className="w-full border rounded-lg p-2"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div>
                  <label className="block text-sm font-medium">Teléfono</label>
                  <input
                    type="text"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    placeholder="Ej: 3101234567"
                    className="w-full border rounded-lg p-2"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium">Teléfono 2</label>
                  <input
                    type="text"
                    name="telefono1"
                    value={formData.telefono1}
                    onChange={handleChange}
                    placeholder="Ej: 6011234567"
                    className="w-full border rounded-lg p-2"
                  />
                </div>
              </div>

              <div className="flex justify-end space-x-2 pt-4">
                <Button
                  type="button"
                  onClick={onClose}
                  className="bg-red-500 hover:bg-red-600 text-white"
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  className={
                    entity
                      ? "bg-yellow-500 hover:bg-yellow-600 text-white"
                      : "bg-blue-600 hover:bg-blue-700 text-white"
                  }
                >
                  {submitText}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default EntityForm;
